'use strict';
realmCommerceApp.config(config);
/*@ngInject*/
function config(platformGAEcommerceConfigProvider){
    platformGAEcommerceConfigProvider.setConfiguration({
        'productDetails': {
            'productId': ['entity_id', 'reference_code'],
            'name': ['label', 'title'],
            'brand': 'publisher',
            'variant': 'format',
            'price': 'price',
            'quantity': 'quantity',
            'staticValues': {
                'category': "Product",
                'coupon': 0,
                'position': 0
            }
        },
        'productListProductDetails': {
            'productId': ['entity_id', 'reference_code'],
            'name': ['label', 'title'],
            'brand': 'publisher',
            'variant': 'format',
            'price': 'price',
            'quantity':'quantity',
            'category': 'productlists[0].label',
            'staticValues': {
                'coupon': 0,
                'position': 0
            }
        },
        'transactionProductDetails': {
            'productId': ['product.entity_id', 'product.reference_code'],
            'name': ['product.label', 'product.title'],
            'price': 'product.price',
            'quantity': 'quantity',
            'brand': 'product.publisher',
            'variant': 'product.format',
            'staticValues': {
                'category': "Product",
                'coupon': 0,
                'position': 0
            }
        }
    });
}


// WEBPACK FOOTER //
// ./static/js/app/config/google.analytics.config.js